import { STEP_ACCOUNT, STEP_ANALYZING, STEP_CONFIRM, STEP_READY, STEP_RETRY, STEP_UPLOAD } from '../../domain/iepReview'
import {
  HEIC_HEIF_MIME_TYPES,
  MIME_TYPE_JPEG,
  MIME_TYPE_PNG,
  MIME_TYPE_WEBP
} from '../../subcomponents/support/imageFiles'

const FLOW_IEP_REVIEW = 'iepReview'

const ACCOUNT_TYPE_NEW = 'new'
const ACCOUNT_TYPE_EXISTING = 'existing'

const REFUSAL_REASON_ANALYSIS_USED = 'analysisUsed'

// This must match the server’s IEP_REVIEW_MAX_STAGING_KEYS.
const MAX_UPLOAD_FILES = 20

// This must match the server’s IEP_REVIEW_CHILD_NAME_MAX_LENGTH.
const CHILD_NAME_MAX_LENGTH = 128

// This must match the server’s IEP_REVIEW_STAGING_MAX_BYTES.
const MAX_UPLOAD_FILE_BYTES = 25 * 1024 * 1024

// This must match the length of the server’s Asset.fileName column.
const MAX_UPLOAD_FILE_NAME_LENGTH = 256

const PDF_MIME_TYPE = 'application/pdf'

// The formats that the drop zone accepts. Images are re-encoded to JPEG before upload, so it is UPLOAD_MIME_TYPES,
// not this list, that must match the server.
const ACCEPTED_FILE_FORMATS = [
  { label: 'PDF', types: [PDF_MIME_TYPE] },
  { label: 'JPG', types: [MIME_TYPE_JPEG] },
  { label: 'PNG', types: [MIME_TYPE_PNG] },
  { label: 'HEIC', types: [...HEIC_HEIF_MIME_TYPES, '.heic', '.heif'] },
  { label: 'WebP', types: [MIME_TYPE_WEBP] }
]

// This must match the server’s IEP_REVIEW_STAGING_MIME_TYPES.
const UPLOAD_MIME_TYPES = [PDF_MIME_TYPE, MIME_TYPE_JPEG, MIME_TYPE_PNG, ...HEIC_HEIF_MIME_TYPES]

const ACCEPTED_FILE_TYPES = ACCEPTED_FILE_FORMATS.flatMap(format => format.types)

const acceptedFormatLabels = ACCEPTED_FILE_FORMATS.map(format => format.label)
const ACCEPTED_FILE_TYPES_LABEL = `${acceptedFormatLabels.slice(0, -1).join(', ')} or ${acceptedFormatLabels.at(-1)}`

export {
  FLOW_IEP_REVIEW,
  STEP_UPLOAD,
  STEP_ACCOUNT,
  STEP_CONFIRM,
  STEP_ANALYZING,
  STEP_RETRY,
  STEP_READY,
  ACCOUNT_TYPE_NEW,
  ACCOUNT_TYPE_EXISTING,
  REFUSAL_REASON_ANALYSIS_USED,
  MAX_UPLOAD_FILES,
  CHILD_NAME_MAX_LENGTH,
  MAX_UPLOAD_FILE_BYTES,
  MAX_UPLOAD_FILE_NAME_LENGTH,
  PDF_MIME_TYPE,
  UPLOAD_MIME_TYPES,
  ACCEPTED_FILE_TYPES,
  ACCEPTED_FILE_TYPES_LABEL
}
